import React from 'react';
import { ComboBox, Item, Text, View } from '@adobe/react-spectrum';
const Sizes = '6\n8\n10\n12\n14\n16\n18\n21\n24\n28\n32\n36\n42\n48\n56\n64\n72\n80\n88\n96\n104\n120\n144'
    .split('\n')
    .map(value => parseInt(value, 10));
export const TextSize = (props) => {
    const { color: _1, sizes: _2, onSelect } = props;
    // const sizeRange = getMarkerSizeRange(sizes);
    // const commonStyle: CSSProperties = {
    //     borderRadius: '10%',
    //     backgroundColor: toCSSColor(color),
    //     width: '100%',
    // };
    const onValueChange = React.useCallback((strValue) => {
        var _a;
        const value = parseInt(String(strValue), 10);
        if (Number.isNaN(value)) {
            return;
        }
        if (value < Sizes[0]) {
            return;
        }
        const projectPreviewStyle = window.getComputedStyle(document.getElementById('project-preview'));
        const projectPreviewFontSize = parseFloat((_a = projectPreviewStyle.fontSize) !== null && _a !== void 0 ? _a : '14px');
        onSelect(value / projectPreviewFontSize);
    }, [onSelect]);
    return (React.createElement(View, { "data-test-id": "text-size-picker" },
        React.createElement(ComboBox, { label: "Font size", width: "size-1200", onInputChange: onValueChange, onSelectionChange: onValueChange, allowsCustomValue: true }, Sizes.map(size => (React.createElement(Item, { key: size },
            React.createElement(Text, { UNSAFE_style: { wordWrap: 'break-word' } }, String(size))))))));
};
